import { Modal, ModalProps } from "react-bootstrap";
import Loader from "./../assets/img/new-ui/Loading.gif";
import Tick from "./../assets/img/new-ui/Tick.gif";

interface LoaderModalProps extends ModalProps {
  onHide: () => void;
}

const LoaderSaveModal = (props: LoaderModalProps) => {
  const { loading, success } = props;

  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="commonModalLoader"
    >
      <Modal.Body className="text-center modalHeight">
        {loading && (
          <>
            <img className="loaderImg" src={Loader} alt="Loading..." />
            <div className="loaderTxt">Your artwork is being saved. Please wait.</div>
          </>
        )}
        {success && (
          <>
            <img className="loaderImg" src={Tick} alt="Success" />
            <div className="loaderTxt">Your artwork is saved successfully</div>
          </>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default LoaderSaveModal;
